import _objectSpread from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";

var res = require('@/config.js');

import { reactive, toRefs } from 'vue';
export default {
  name: 'TheEnd',
  setup: function setup() {
    // 赋值
    var data = reactive({
      title: res.the_end.title,
      text: res.the_end.text
    });

    var callBack = function callBack() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }; // 结构导出


    var dataOut = toRefs(data);
    return _objectSpread({
      callBack: callBack
    }, dataOut);
  }
};